/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, Input, ViewChild, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ImageInputComponent } from 'admin-drivers/src/app/common/components/image-input/image-input.component';
import { LicenseCategory } from 'admin-drivers/src/app/common/models/LicenseCategory';
import { LicenseCategoryService } from 'admin-drivers/src/app/api/services/license-category.service';

@Component({
  selector: 't-llevo-edit-license-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ImageInputComponent,
  ],
  templateUrl: './edit-license-form.component.html',
  styles: `
    @import '../../../../utils/styles/formGroup.scss';
    .licenseForm{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, auto);

      & > mat-form-field:nth-child(-n + 5) {
        width: 90%;
        justify-self: center;
      }

      & > t-llevo-image-input{
        width: 90%;
        grid-row: 1 / span 4;
        grid-column: 2;
        justify-self: center;
        max-height: 300px;
      }
    }
  `
})
export class EditLicenseFormComponent {
  @Input({required: true}) frm! : FormGroup

  protected maxApprovedDate = new Date();
  protected minExpirationDate = new Date();
  protected licenseCategories: LicenseCategory[] = [];

  private licenseCatSrv = inject(LicenseCategoryService);
  private destroyRef = inject(DestroyRef);

  @ViewChild('image') imageRef!: ImageInputComponent

  constructor() {
    this.licenseCatSrv.categories$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          if (data) {
            this.licenseCategories = data;
          } else {
            this.licenseCatSrv.getCategories().pipe(take(1)).subscribe();
          }
        },
      });
  }

  get categories() {
    return this.frm.controls['categories'];
  }

  get licenseNumber() {
    return this.frm.controls['licenseNumber'];
  }

  get expeditionDate() {
    return this.frm.controls['expeditionDate'];
  }

  get expiredYear() {
    return this.frm.controls['expiredYear'];
  }

  get image() {
    return this.frm.controls['image'] as FormControl<File | null>;
  }

  loadImage(url: string) {
    this.imageRef.loadImage(url)
  }
}
